import React, { useEffect } from 'react';
import { App } from 'antd';
import { setAntdGlobal } from '../utils/antdGlobal';

/**
 * 放在 <App> 组件内部，将主题感知的 message/modal/notification 实例注入全局
 * 解决 "Static function can not consume context like dynamic theme" 警告
 */
const AntdAppHelper: React.FC = () => {
  const { message, modal, notification } = App.useApp();

  useEffect(() => {
    setAntdGlobal(message, modal, notification);
  }, [message, modal, notification]);

  return null;
};

export default AntdAppHelper;
